export class IncontactApiError extends Error {
  constructor(statusCode, statusText, errorMessage, responseText, context = {}) {
    super(errorMessage || statusText || "API Error");
    this.name = "IncontactApiError";
    this.statusCode = statusCode;
    this.statusText = statusText;
    this.errorMessage = errorMessage;
    this.responseText = responseText;
    this.context = context;
    this.timestamp = new Date().toISOString();

    // Capture stack trace
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, IncontactApiError);
    }
  }

  toString() {
    return `[${this.statusCode}] ${this.message}: ${this.errorMessage || "No details"}`;
  }

  // Create a loggable object with all relevant information
  toLog() {
    return {
      name: this.name,
      message: this.message,
      statusCode: this.statusCode,
      statusText: this.statusText,
      errorMessage: this.errorMessage,
      context: this.context,
      timestamp: this.timestamp,
      stack: this.stack,
    };
  }
}
